export const calculateQueueRecipeProgress = (recipesInQueue: any[]) => {
  if (!recipesInQueue?.length) return 0;

  // Current time
  const now = Date.now();

  const currentRecipe = recipesInQueue.find(
    (item) =>
      new Date(item.craftStartTime).getTime() <= now &&
      new Date(item.craftStartTime).getTime() + item.craftDuration * item.multiplyModifier * 1000 >= now
  );

  if (!currentRecipe) {
    return 0;
  }

  const startTime = new Date(currentRecipe.craftStartTime).getTime();
  const duration = currentRecipe.craftDuration * currentRecipe.multiplyModifier * 1000;

  // Percentage calculation
  // const percentage = (endTime - Date.now()) / duration;
  const percentage = (Date.now() - startTime) / duration;

  // Clamp between 0 and 1
  return Math.max(0, Math.min(1, percentage));
};
